var NahmSpirit = NahmSpirit || {};

NahmSpirit.Price = function () {

  var _selected = {
    varietyBtn: '.menu-item__variety',
    menuItemPrice: '.menu-item__price',
    activeClass: 'text-tertiary',
    currentPrice: ''
  };

  var _checkAndShowDishPrice = function () {
    $(_selected.varietyBtn).each(function () {
      var cached = $(this);
      if (cached.hasClass(_selected.activeClass)) {
        _selected.currentPrice = cached.data('price');
        // _showDishPrice(cached);
      }
			cached.parents().prev(_selected.menuItemPrice).html('<span style="color:#999;">&hellip;</span>'); //added 20230912
    });
  }

  // handle click event and get the specific price
  var _handleMenuVarietyBtnClick = function (e){
    e.preventDefault();
    var cachedMenuVarietyBtn = $(this);
    _activateAndDeactivateBtn(cachedMenuVarietyBtn);
    var price = cachedMenuVarietyBtn.data('price');
    _selected.currentPrice = price;
    _showDishPrice(cachedMenuVarietyBtn);
  }

  // show the dish price
  var _showDishPrice = function (cached) {
    cached.parents().prev(_selected.menuItemPrice).html('&euro; '+_selected.currentPrice);
  }

  // activate and deactivate button
  var _activateAndDeactivateBtn = function (cachedData) {
    if(cachedData.hasClass(_selected.activeClass)) {
      _removeAllSiblingsClass(cachedData);
    } else {
      _removeAllSiblingsClass(cachedData);
      cachedData.addClass(_selected.activeClass);
    }
  }

  // remove all siblings class
  var _removeAllSiblingsClass = function (cachedData) {
    cachedData.nextAll().removeClass(_selected.activeClass);
    cachedData.prevAll().removeClass(_selected.activeClass);
  }

  var _init = function () {
    _checkAndShowDishPrice();
    $(_selected.varietyBtn).on('click', _handleMenuVarietyBtnClick)
  }

  /** PUBLIC API **/
  return {
    init: function () { return _init(); }
  };

}();

jQuery(function () {
  NahmSpirit.Price.init();
});

